import React from "react";
import {Box, Typography} from "@mui/material";
import type {Opportunity} from "../opportunityIntelligenceDemoData";
import {formatCompactCurrency, groupBySource, SOURCE_KIND_LABEL, sourceKindColor} from "../opportunityUtils";
import {SOURCE_ICON} from "./OpportunityCells";
import {PlainOpportunityTable} from "./PlainOpportunityTable";

type Props = { rows: Opportunity[] };

export const BySourceView: React.FC<Props> = ({rows}) => {
    const groups = React.useMemo(() => groupBySource(rows), [rows]);

    return (
        <Box className="oi-source-groups">
            {groups.map(group => {
                const color = sourceKindColor(group.kind);
                const Icon = SOURCE_ICON[group.kind];
                const currency = group.items[0]?.currency ?? 'EUR';
                return (
                    <Box key={group.label} className="oi-group-card">
                        <Box className="oi-group-header">
                            <span className="oi-group-icon" style={{backgroundColor: `${color}1f`, color}}>
                                <Icon sx={{fontSize: 20}}/>
                            </span>
                            <Box flexGrow={1}>
                                <Typography className="oi-group-title">{group.label}</Typography>
                                <Typography className="oi-group-sub">
                                    {SOURCE_KIND_LABEL[group.kind]} · {group.items.length} item{group.items.length > 1 ? 's' : ''}
                                </Typography>
                            </Box>
                            <Box className="oi-group-value">
                                <span className="oi-group-value-amount">{formatCompactCurrency(group.combinedValue, currency)}</span>
                                <span className="oi-group-value-label">Combined value</span>
                            </Box>
                        </Box>
                        <PlainOpportunityTable rows={group.items} showSource={false}/>
                    </Box>
                );
            })}
        </Box>
    );
};
